var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('message-center'),_c('message-box'),(_vm.$route.name === 'login')?_c('router-view'):_c('app-shell')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }